import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { escapeRegExp, mapValues, orderBy, padStart, values } from 'lodash-es';
import { isoLangs } from './iso-lang-list';

export const languages = values(mapValues(isoLangs, (li, code) => { return {...li, code, nativeName : li.nativeName.split(' ')[0]} }));


@Component({
  selector: 'app-translation-dropdown',
  templateUrl: './translation-dropdown.component.html',
  styleUrls: ['./translation-dropdown.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class TranslationDropdownComponent implements OnInit {
  _current:string;
  @Input() set current(v:string) {
    if (this._current === v) return;
    this._current = v;
    this.currentChange.next(v);
  }
  get current () {
    return this._current;
  }
  
  @Output() currentChange = new EventEmitter<string>();
  _used:string[] = [];
  get used () {
    return this._used;
  }
  @Input() set used(v:string[]) {
    if (this._used === v) return;
    this._used = v;
    this.updateList();
  }
  @Input() preferred:string[] = ['ko', 'en', 'vi', 'ru'];
  @Input() mode:'edit'|'view' = 'view'; 
  @Output() onDelete = new EventEmitter<string>();

  query:string = '';
  AvailableLanguages:{code:string, name:string, nativeName:string}[] = []; 
  usedLanguages:{code:string, name:string, nativeName:string}[] = [];
  get currentLanguage () {
    return languages.find(lang=>lang.code === this.current);
  }

  constructor(
    ) { }

  ngOnInit() {
    this.updateList();
  }
  updateList(query?:string) {

    this.usedLanguages = languages.filter(lang=>this.used.includes(lang.code));

    this.AvailableLanguages = orderBy(languages.filter(lang=>{
      if (this.used.includes(lang.code)) return false;
      if (query && !lang.name.match(new RegExp(escapeRegExp(query), 'i')) && !lang.nativeName.match(new RegExp(escapeRegExp(query), 'i'))) return false;
      return true;
    }), li=>{
      const prefered_index = this.preferred.indexOf(li.code);
      return `${prefered_index !== -1 ? padStart(''+prefered_index, 3, '0') : 999 }-${li.name}`;
    });
  }

  delete (code:string) {
    if (this.current === code) this.current = this.used[this.used.indexOf(this.current) - 1];
    this.used.splice(this.used.indexOf(code), 1);
    this.updateList();
    this.onDelete.next(code);
  }
  add (code:string) {
    this.used.push(code);
    this.updateList();
  }
}
